// extracted by mini-css-extract-plugin
module.exports = {"section":"B8s30jr _1npT0qO _3iUUIoT IOKb3Ut","row":"_157dQ3n _2wW_gNj","full_col":"_1ZUOyoR _1npT0qO"};